import React, { useState, useEffect } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { handleValidateObj } from 'constants/objValues/objvalues';
import ParkProposition from 'components/sales/formSection/parkProposition/parkProposition';
import FileUpload from 'components/sales/fileUpload/fileUpload';

const Proposition = ({
  dropDownData,
  handleValue,
  leadId,
  documentUploadUrl,
}) => {
  const inputs = {
    proposition_for_client: '',
    proposition_for_park_plus: '',
  };

  const [isRequired, setRequired] = useState(false);
  const [formData, setData] = useState(inputs);
  const [docs, setDocs] = useState(null);
  const [propositionArr, setPropositionArr] = useState([]);

  const handleParkProposition = (val) => {
    if (val !== null && val !== undefined && val !== '') {
      setRequired(false);
      if (propositionArr.length === 0) {
        propositionArr.push(val.proposition_for_park_plus[0]);
        setPropositionArr(propositionArr);
      } else {
        const findIndex = propositionArr.findIndex(
          (obj) =>
            Object.keys(obj)[0] ===
            Object.keys(val.proposition_for_park_plus[0])[0]
        );
        if (findIndex === -1) {
          propositionArr.push(val.proposition_for_park_plus[0]);
          setPropositionArr([...propositionArr]);
        } else {
          propositionArr.splice(findIndex, 1);
          propositionArr.push(val.proposition_for_park_plus[0]);
          setPropositionArr([...propositionArr]);
        }
      }
      setData({
        ...formData,
        proposition_for_park_plus: propositionArr,
      });
    } else {
      setRequired(true);
      setData({
        ...formData,
        proposition_for_park_plus: '',
      });
    }
  };

  const handleSubmitData = () => {
    const isNotEmpty = handleValidateObj(formData);
    if (isNotEmpty !== false) {
      handleValue({
        ...formData,
        lead_id: leadId,
        proposition_for_client_ref: docs,
      });
    }
  };

  useEffect(() => {
    handleSubmitData();
  }, [formData]);

  return (
    <FormSection title={localization.valProp}>
      <ConstantInput
        label={localization.valPropClient}
        errorMsg={
          formData.proposition_for_client === ''
            ? localization.isRequired
            : localization.requiredCharacter
        }
        regex={Regex.text.test(formData.proposition_for_client)}
        inputValue={formData.proposition_for_client}
        type="text"
        handleChange={(value) =>
          setData({ ...formData, proposition_for_client: value })
        }
        required
        isStarRequired={true}
      />
      <FileUpload
        documentUploadUrl={documentUploadUrl}
        accept=".pdf, .jpg, .png, .docx, .doc"
        id="upload_docs"
        onChange={(val) => setDocs(val)}
      >
        <span className="btn btn-transparent">
          {localization.uploadReferenceDocument}
        </span>
      </FileUpload>
      <h5 className="w-100">{localization.valPropForUs}</h5>
      {dropDownData.valueProposition &&
        dropDownData.valueProposition.map((item) => {
          return (
            <div className="w-100" key={item.id}>
              <div className="d-inline-block">
                <ParkProposition
                  label={item.name}
                  item={item}
                  handleValue={handleParkProposition}
                  parkProp={true}
                />
              </div>
            </div>
          );
        })}
      {isRequired === true ? (
        <span className="checkbox-required error">
          {localization.enterField}
        </span>
      ) : null}
    </FormSection>
  );
};

export default Proposition;
